import axios from "axios";
import { toast, Bounce } from "react-toastify";

const jwtToken = localStorage.getItem("jwtToken");

export const getAllValue = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/stats",
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.message !== "Not authorized, missing user") {
        dispatch({ type: "GET_ALL_VALUES", payload: response.data });
        dispatch({ type: "HIDE_CLAIM" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const checkMultiClaims = () => {
  return async (dispatch) => {
    try {
      await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/check-multi-claims",
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  };
};

export const getClaims = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/getClaims",
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({ type: "GET_ALL_CLAIMS", payload: response.data });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getUserClaims = (userName) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/getUserClaims",
        {userName},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({ type: "GET_ALL_CLAIMS", payload: response.data });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getBadge = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/getBadge",
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({ type: "GET_ALL_BADGE", payload: response.data.badge });
    } catch (error) {
      console.error(error);
    }
  };
};

export const partiallyApproved = (claimantId, firstAnswer, secondAnswer) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/partiallyApproved`,
        { firstAnswer, secondAnswer },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.success(response.data.success, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
        dispatch({ type: "SET_BADGE_GIFT", payload: "Partially Approved" })
      }
      dispatch(getClaims());
    } catch (error) {
      console.error(error);
    }
  };
};

export const startCountdown = (claimantId, actionFlag) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/start-assessment`,
        { actionFlag },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
        dispatch({ type: "SET_BADGE_GIFT", payload: "Congratulation" })
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const deleteClaim = (claimantId, currentUserName) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/deleteClaim`,
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch(getUserClaims(currentUserName));
        dispatch(getUserValue(currentUserName));
        dispatch({ type: "SET_AUDIO" });
        dispatch({ type: "SET_BADGE_GIFT", payload: "Deleted" })
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const decideClaim = (claimantId, actionFlag) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/assessment-decision`,
        { actionFlag },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
        if (response.data.approved) {
          dispatch({ type: "SET_BADGE_GIFT", payload: "Approved" })
        }
        dispatch(getAllValue());
      }
      if (response.data.success === false) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO_OH" });
        dispatch({ type: "SET_NO_GIFT" });
        dispatch(getAllValue());
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const undoAFCAAppeal = (claimantId, decision) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/appeal-decision`,
        { decision },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const fullyApproved = (claimantId, actionFlag) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/sow-approved`,
        { actionFlag },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
        if (response.data.approved) {
          dispatch({ type: "SET_BADGE_GIFT", payload: "Fully Approved" })
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const fullDenial = (claimantId, actionFlag) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-threat`,
        { actionFlag },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const sendReminder = (claimantId) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/send-reminder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const getTopDefenders = (type) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/byTotalPoints`,
        { type },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch({ type: "SET_LEADERS", payload: response.data.result });
        dispatch({ type: "SET_SYMBOL", payload: response.data.symbol });
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const signOut = () => {
  return async (dispatch) => {
    localStorage.clear();
    window.location.href = "/";
    try {
      toast.success("Successfully SignOuted!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } catch (error) {
      console.error(error);
    }
  };
};
export const saveAppealSentDate = (date, claimantId) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afcaAppealSent`,
        { date },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch(getClaims());
        dispatch(getAllValue());
        dispatch(getBadge());
        if (response.data.badgeUnlock === "AFCA Warrior") {
          dispatch({ type: "SET_AFCA_WARRIOR"})
          dispatch({ type: "SET_BADGE_GIFT", payload: "'AFCA Warrior' badge added, You’ve earned this badge simply by Sent 10 AFCA threats!" })
        } else if (response.data.badgeUnlock === "AFCA General") {
          dispatch({ type: "SET_AFCA_GENERAL"})
          dispatch({ type: "SET_BADGE_GIFT", payload: "'AFCA General' badge added, You’ve earned this badge simply by Sent 50 AFCA threats!" })
        } else if (response.data.badgeUnlock === "Sending the First Threat") {
          dispatch({ type: "SET_FIRST_THREAT"})
          dispatch({ type: "SET_BADGE_GIFT", payload: "'Sending the First Threat' badge added, You’ve earned this badge simply by sending First AFCA threat!" })
        } else {
          dispatch({ type: "SET_AUDIO_AFCA" });
        }
      }
    } catch (error) {
      console.error("Error starting scraper:", error);
    }
  };
};

export const afcaSowEmailSent = (claimantId) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/sow-reminder`,
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};



export const undoCashSattlement = (claimantId) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/undoCashSattlement`,
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch(getClaims());
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
        dispatch(getClaims());
        dispatch(getAllValue());
      }
    } catch (error) {
      console.error(error);
    }
  };
};


export const undoDeclined = (claimantId, decision) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-appeal-decision`,{ decision },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        dispatch({ type: "SET_AUDIO" });
        dispatch(getClaims());
        dispatch(getAllValue());
      }
    } catch (error) {
      console.error(error);
    }
  };
};

export const saveReview = (userId, reviewDate, reviewStar, reviewContent) => {
  return async (dispatch) => {
    if (reviewDate === "") {
      toast.warn("Please enter the reviewDate!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (reviewStar === "") {
      toast.warn("Please enter the reviewStar!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (reviewContent === "") {
      toast.warn("Please enter the reviewContent!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      axios.post("https://api.claimdefenderaigame.com:5000/api/claims/reviewCreate",
          {
            userId,
            reviewDate,
            reviewStar,
            reviewContent
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            toast.success("Successfully created!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            dispatch(getAllValue());
            dispatch(getClaims());
            dispatch(getBadge());
            
            if (res.data.badgeUnlock.includes("Client Champion")) {
              dispatch({ type: "SET_GOOGLE_REVIEW_AUDIO" });
              dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by getting 5 five-star Google reviews" })
            } else if (res.data.badgeUnlock.includes("100K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "100K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `100K Club - You’ve earned this badge simply by getting 100K points` });
            } else if (res.data.badgeUnlock.includes("75K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "75K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `75K Club - You’ve earned this badge simply by getting 75K points` });
            } else if (res.data.badgeUnlock.includes("50K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "50K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `50K Club - You’ve earned this badge simply by getting 50K points` });
            } else if (res.data.badgeUnlock.includes("25K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "25K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `25K Club - You’ve earned this badge simply by getting 25K points` });
            } else if (res.data.badgeUnlock.includes("10K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "10K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `10K Club - You’ve earned this badge simply by getting 10K points` });
            } else if (res.data.badgeUnlock.includes("5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `5K Club - You’ve earned this badge simply by getting 5K points` });
            } else if (res.data.badgeUnlock.includes("2.5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "2.5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `2.5K Club - You’ve earned this badge simply by getting 2.5K points` });
            } else if (res.data.badgeUnlock.includes("1K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "1K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `1K Club - You’ve earned this badge simply by getting 1K Club` });
            } else if (res.data.badgeUnlock.includes("500 Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "500 Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `500 Club - You’ve earned this badge simply by getting 500 points}` });
            } else {
              if (reviewStar == 5) {
                dispatch({ type: "SET_AUDIO" });
                dispatch({ type: "SET_BADGE_GIFT", payload: "+500 POINTS!" })
              } else {
                dispatch({ type: "SET_AUDIO" });
                dispatch({ type: "SET_BADGE_GIFT", payload: `Saved ${reviewStar} reviews!` })
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};

export const saveReferral = (userId, referralName, referralAddress, referralPhoneNumber) => {
  // const { setAudioURL } = useAudio();
  
  return async (dispatch) => {
    if (referralName === "") {
      toast.warn("Please enter the referralName!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (referralAddress === "") {
      toast.warn("Please enter the referralAddress!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (referralPhoneNumber === "") {
      toast.warn("Please enter the referralPhoneNumber!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      axios.post("https://api.claimdefenderaigame.com:5000/api/claims/referralCreate",
          {
            userId,
            referralName, 
            referralAddress, 
            referralPhoneNumber
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            toast.success("Successfully created!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            dispatch(getAllValue());
            dispatch(getClaims());
            dispatch(getBadge());
            if (res.data.badgeUnlock.includes('Referral Master')) {
              dispatch({ type: "SET_REFERRAL_AUDIO" });
              dispatch({ type: "SET_BADGE_GIFT", payload: "Referral Master - You’ve earned this badge simply by Completing 3 successful referrals" });
            } else if (res.data.badgeUnlock.includes("100K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "100K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `100K Club - You’ve earned this badge simply by getting 100K points` });
            } else if (res.data.badgeUnlock.includes("75K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "75K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `75K Club - You’ve earned this badge simply by getting 75K points` });
            } else if (res.data.badgeUnlock.includes("50K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "50K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `50K Club - You’ve earned this badge simply by getting 50K points` });
            } else if (res.data.badgeUnlock.includes("25K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "25K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `25K Club - You’ve earned this badge simply by getting 25K points` });
            } else if (res.data.badgeUnlock.includes("10K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "10K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `10K Club - You’ve earned this badge simply by getting 10K points` });
            } else if (res.data.badgeUnlock.includes("5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `5K Club - You’ve earned this badge simply by getting 5K points` });
            } else if (res.data.badgeUnlock.includes("2.5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "2.5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `2.5K Club - You’ve earned this badge simply by getting 2.5K points` });
            } else if (res.data.badgeUnlock.includes("1K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "1K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `1K Club - You’ve earned this badge simply by getting 1K Club` });
            } else if (res.data.badgeUnlock.includes("500 Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "500 Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `500 Club - You’ve earned this badge simply by getting 500 points}` });
            } else {
              dispatch({ type: "SET_BADGE_GIFT", payload: "+1000 points saved!" })
              dispatch({ type: "SET_AUDIO" });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};



export const saveBreach = (userId, recordedBreach, insurerName, typeOfBreach, recordedDate, emailDate) => {
  return async (dispatch) => {
    if (recordedBreach === "") {
      toast.warn("Please enter the recordedBreach!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (insurerName === "") {
      toast.warn("Please enter the insurerName!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (recordedDate === "") {
      toast.warn("Please enter the recordedDate!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (emailDate === "") {
      toast.warn("Please enter the emailDate!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else if (typeOfBreach === "") {
      toast.warn("Please enter the typeOfBreach!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      axios.post("https://api.claimdefenderaigame.com:5000/api/claims/breachCreate",
          {
            userId,
            recordedBreach,
            insurerName, 
            typeOfBreach, 
            recordedDate, 
            emailDate
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            toast.success("Successfully created!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            if (res.data.badgeUnlock.includes("100K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "100K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `100K Club - You’ve earned this badge simply by getting 100K points` });
            } else if (res.data.badgeUnlock.includes("75K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "75K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `75K Club - You’ve earned this badge simply by getting 75K points` });
            } else if (res.data.badgeUnlock.includes("50K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "50K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `50K Club - You’ve earned this badge simply by getting 50K points` });
            } else if (res.data.badgeUnlock.includes("25K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "25K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `25K Club - You’ve earned this badge simply by getting 25K points` });
            } else if (res.data.badgeUnlock.includes("10K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "10K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `10K Club - You’ve earned this badge simply by getting 10K points` });
            } else if (res.data.badgeUnlock.includes("5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `5K Club - You’ve earned this badge simply by getting 5K points` });
            } else if (res.data.badgeUnlock.includes("2.5K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "2.5K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `2.5K Club - You’ve earned this badge simply by getting 2.5K points` });
            } else if (res.data.badgeUnlock.includes("1K Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "1K Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `1K Club - You’ve earned this badge simply by getting 1K Club` });
            } else if (res.data.badgeUnlock.includes("500 Club")) {
              dispatch({ type: "SET_CLUB_AUDIO", payload: "500 Club" });
              dispatch({ type: "SET_BADGE_GIFT", payload: `500 Club - You’ve earned this badge simply by getting 500 points}` });
            } else {
              dispatch({ type: "SET_BADGE_GIFT", payload: "+2000 POINTS!" })
              dispatch({ type: "SET_AUDIO" });
            }
            dispatch(getAllValue());
            dispatch(getClaims());
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};



export const getUserValue = (userName) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/getUserValue",
        {userName},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({type: "SET_CURRENT_USERNAME", payload: userName})
      dispatch({ type: "SHOW_CLAIM" });
      dispatch({ type: "GET_ALL_VALUES", payload: response.data });
    } catch (error) {
      console.error(error);
    }
  };
};

export const pointsManager = (userName, pointType, pointsAmount) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/pointsManager",
        {userName, pointType, pointsAmount},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.success("successfully changed points!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        dispatch({ type: "SET_AUDIO" });
      }
    } catch (error) {
      console.error(error);
    }
  };
};


export const getAllReviewData = (userName) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        "https://api.claimdefenderaigame.com:5000/api/claims/getAllReviewData",
        {userName},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({ type: "GET_ALL_REVIEW_DATA", payload: response.data });
    } catch (error) {
      console.error(error);
    }
  };
};



export const earlyLearner = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `https://api.claimdefenderaigame.com:5000/api/claims/earlyLearner`,
        {},
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        if (response.data.badgeUnlock === 1) {
          dispatch({ type: "SET_LEANER_BADGE" })
          dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by clicking on the Points Guide" })
          dispatch(getBadge());
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
};